import axios from "axios";

export type PostcodeLookupResult = {
  lat: string;
  lon: string;
  adminDistrict: string;
};

export async function getLatLonFromPostcode(postcode: string) {
  try {
    const res = await axios
      .get(`https://api.postcodes.io/postcodes/${postcode}`)
      .then((response) => {
        const lat = response.data.result.latitude.toString();
        const lon = response.data.result.longitude.toString();
        const adminDistrict = response.data.result.admin_district ?? "";

        return { lat, lon, adminDistrict } satisfies PostcodeLookupResult;
      });
    return res;
  } catch (error) {
    console.error(error);
  }
}